import { useCallback, useState } from "react";
import { sanitizePriceInput } from "./sanitizePriceInput";

interface Props {
  min?: number;
  max?: number;
}

export function usePriceInput(initial: string = "", { min, max }: Props = {}) {
  const [input, setInput] = useState(initial);

  const onChange = useCallback(
    (value: string) => {
      setInput(sanitizePriceInput(value, { min, max, maxFractionDigits: 2 }));
    },
    [max, min],
  );

  return [input, onChange] as const;
}
